import { useUser } from '../../entites/authorization/use-user.ts';
import { useCartProductsStore } from '../../entites/cart/use-cart-products.store.ts';
import { useFavoriteProductsStore } from '../../entites/favorite/use-favorite-products.store.ts';
import { CartProductProps } from '@ui/cart';
import { F } from '@shared/utils/format.ts';

export function useCart() {
  const { isUseCache } = useUser();
  const {
    removeProductById,
    data,
    updateValue,
    canSetValue,
    isLoading,
    productIds,
  } = useCartProductsStore({
    isUseCache,
  });
  const favoriteStore = useFavoriteProductsStore({ isUseCache });

  const mapped = data.map((item) => {
    const info: CartProductProps = {
      image: item.main_photo || undefined,
      title: item.name,
      itemPrice: `${item.price} ₸`,
      price: `${item.price ? Number(item.price) * item.value : 0} ₸`,
      description: item.short_description || undefined,
      value: item?.value?.toString() || undefined,
      isFavorite: favoriteStore.isFavorite(item.id),
      onFavoritePress: () => favoriteStore.invertProduct(item),
      onMinusPress: () => {
        if (canSetValue(item.id, item.value - 1)) {
          updateValue(item.id, item.value - 1);
        }
      },
      onPlusPress: () => {
        if (canSetValue(item.id, item.value + 1)) {
          updateValue(item.id, item.value + 1);
        }
      },
      onTrashPress: () => removeProductById(item.id),
      isLoading: false,
      isEditable: true,
    };

    return info;
  });

  const checkoutMapped = data.map((item) => {
    return {
      image: item.main_photo || undefined,
      title: item.name,
      description: item.short_description || undefined,
      price: `${item.price} ₸`,
      value: item?.value?.toString() || undefined,
      isFavorite: favoriteStore.isFavorite(item.id),
      isLoading: false,
      isEditable: false,
      trailing: '4 шт',
    };
  });

  const sum = data.reduce((acc, value) => {
    return acc + value.value * (value.price ? Number(value.price) : 0);
  }, 0);

  const count = data.length;

  const array = Array(5)
    .fill(undefined)
    .map(() => ({
      isLoading: true,
    }));

  return {
    data: isLoading && mapped.length === 0 ? array : mapped,
    checkout: checkoutMapped,
    isLoadingSum: false,
    isShowControl: isLoading || mapped.length > 0,
    sum: F.number(sum),
    count,
    productIds,
  };
}
